import { serializeSearchParams } from '../actions/utils';
import * as types from './types';

function setSearchResults(searchId, batchId, tripIds, tripMetadata, override = false) {
    return {
        meta: {
            searchId,
            batchId,
            override,
        },
        payload: {
            tripIds,
            tripMetadata,
        },
        type: types.SET_SEARCH_RESULTS,
    };
}

function clearSearchResults(opts) {
    const searchId = serializeSearchParams(opts);
    return {
        meta: searchId,
        type: types.CLEAR_SEARCH_RESULTS,
    };
}

export {
    clearSearchResults,
    setSearchResults,
};
